import { GameRecordBase } from '../../shared/models/game-record-base';
import type { GameRecordOptions } from '../../shared/models/game-record-base';

/**
 * NFL-specific GameRecord.
 * - Includes ties in the denominator (W+L+T).
 * - zeroGamesValue: 0, zeroPctValue: 0 (matches legacy NFL behavior).
 */
export class NflGameRecord extends GameRecordBase {
  static readonly NFL_OPTIONS: Partial<GameRecordOptions> = {
    includeTiesInDenominator: true,
    zeroGamesValue: 0,
    zeroPctValue: 0,
  };

  constructor(fakeObs: KnockoutObservable<number | undefined>) {
    super(fakeObs, NflGameRecord.NFL_OPTIONS);
  }
}
